import { useQuery } from '@tanstack/react-query';
import { fetchApi } from '../fetch-api';
import { idacOrigin } from '../env';
import { LoginPageState } from '../../containers/LoginPage';

type PageState = {
  '/login/state': LoginPageState;
};

export const usePageState = <Path extends keyof PageState, State extends PageState[Path]>(
  path: Path
) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [window.location.pathname],
    queryFn: async () => {
      const response = await fetchApi(idacOrigin + path);
      const data = (await response.json()) as State;
      return data;
    },
  });

  return {
    state: data,
    isLoading,
    isError,
    error,
  };
};
